import React from 'react';

import { TwPicture } from '@boc/images';

import { imgUrl } from '~/urls';

const Aboutus = () => {
  return (
    <>
      <div className="font-family-content text-primary-2-80 flex flex-col gap-y-16 py-20 text-2xl font-normal">
        <h1 className="font-heading-condensed text-center text-6xl font-medium lg:text-8xl">
          Hello! We&apos;re Jigsaw Nation. We love puzzles and we love art!
        </h1>

        <div>
          <TwPicture
            imgUrl={imgUrl}
            src={'/static/about-us/jsn-team.png'}
            alt="Jigsawnation Team"
            defaultSize={800}
            twSizes={{ lg: 1000 }}
            className="h-96 object-cover lg:h-full lg:w-full"
          />
        </div>

        <div className="flex flex-col-reverse gap-y-10 md:flex-col-reverse lg:grid lg:grid-cols-2 lg:gap-x-20">
          <TwPicture
            imgUrl={imgUrl}
            src={'/static/about-us/jsn-team-childhood.png'}
            alt="Jigsaw Nation Team childhood"
            defaultSize={800}
            twSizes={{ lg: 1000 }}
            className="h-full w-full"
          />

          <div className="flex flex-col gap-y-10">
            <p>
              As young kids of the Bookwala household, our childhood was full of fun- whether we
              were wrestling each other to the floor or playing a game of Monopoly. But as we grew
              up, we noticed a shift. Kids seemed to be drifting away from games and puzzles. Queue;
              Jigsaw Nation.
            </p>

            <p>
              In 2020, we decided to go on our own puzzling journey. Fuelled by our love for solving
              puzzles and curating art, we set out to create the perfect puzzle. We work hard
              everyday to make premium quality puzzles that make the &apos;click&apos; satisfying
              and worthy. We hope you find as much joy in solving them as we do in crafting them.
            </p>
          </div>
        </div>

        <div className="flex w-full flex-col gap-y-5 lg:items-center lg:justify-center">
          <h1 className="font-heading-condensed text-left text-6xl font-medium">Support Local</h1>

          <div className="flex flex-col gap-y-5 text-left lg:w-2/5">
            <p>
              In our quest to solve our personal puzzle cravings we ended up creating puzzles we
              love with artists we love! Now introducing; JSN Originals.
            </p>
            <p>
              These puzzles are more than just pieces, they&apos;re a space for local artists to
              bring their art to a broader audience. It&apos;s our way of bringing creativity to the
              world; one puzzle piece at a time.
            </p>
          </div>
        </div>

        <div>
          <TwPicture
            imgUrl={imgUrl}
            src={'/static/about-us/puzzle-playing.png'}
            alt="Playing Puzzle"
            defaultSize={800}
            twSizes={{ lg: 1000 }}
            className="h-96 object-cover lg:h-full lg:w-full"
          />
        </div>

        <div className="flex flex-col gap-y-5 lg:grid lg:grid-cols-2 lg:gap-x-20">
          <div className="flex flex-col gap-y-7">
            <h1 className="font-heading-condensed col-span-2 text-center text-6xl font-medium">
              Toss the screens aside!
            </h1>

            <p>
              Here at Jigsaw Nation, we don&apos;t have grand mottos or vision statements, but we
              genuinely believe in the magic that happens when you spend time with the people you
              love, doing things you love. Be it playing games, solving puzzles, or just chilling in
              front of the TV—it&apos;s all about being present.
            </p>

            <p>
              In our quest for real-world fun, we started The Bored Game Company. Our way of
              bringing the board game revolution to India. We localise, manufacture and sell a
              variety of action packed board games.
            </p>
          </div>

          <TwPicture
            imgUrl={imgUrl}
            src={'/static/about-us/team-event.png'}
            alt="Enjoying at an event"
            defaultSize={800}
            twSizes={{ lg: 1000 }}
            className="h-full w-full"
          />
        </div>
      </div>
    </>
  );
};

export default Aboutus;
